import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { Member } from '@gem/call/CallStore/Member/Member';
import { CallMemberRole } from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import { IcDeleteIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IPopoverMenuItem } from '@gem/ui-kit';

import { ICallSpeakerPermissionsItemProps } from './CallSpeakerPermissionsItem.types';

interface ICallSpeakerPermissionsItemPresenter {
  userId: string;
  isPopoverOpened: boolean;
  channelId: string | null;
  ongoingCall: Call;
  member: Member | null;
  menu: IPopoverMenuItem[];
  togglePopover(): void;
  closePopover(): void;
  onRemoveSpeaker(): void;
}

export const useCallSpeakerPermissionsItemPresenter = (
  props: ICallSpeakerPermissionsItemProps
): ICallSpeakerPermissionsItemPresenter => {
  const { t } = useTranslation();

  const presenter = useLocalObservable<ICallSpeakerPermissionsItemPresenter>(() => ({
    userId: props.userId,
    isPopoverOpened: false,

    get ongoingCall(): Call {
      return props.call;
    },

    get channelId(): string | null {
      return presenter.ongoingCall.channelId || null;
    },

    get member(): Member | null {
      return props.call.members.getMemberById(presenter.userId);
    },

    get menu(): IPopoverMenuItem[] {
      return [
        {
          key: 'remove-speaker',
          icon: IcDeleteIcon,
          title: t('webinar_remove_speaker_action'),
          onClick: presenter.onRemoveSpeaker,
        },
      ];
    },

    togglePopover(): void {
      this.isPopoverOpened = !this.isPopoverOpened;
    },

    closePopover(): void {
      this.isPopoverOpened = false;
    },

    onRemoveSpeaker(): void {
      if (presenter.channelId) {
        props.callController.setCallParticipantsRoles(presenter.channelId, [
          {
            userId: presenter.userId,
            role: CallMemberRole.Member,
          },
        ]);
      }
    },
  }));

  useEffect(() => {
    presenter.userId = props.userId;
  }, [props.userId]);

  return presenter;
};
